<template>
  <div class="app">
    <RouterHeader @change="change" :lan="lan" :menuList="menuList" :n="index" v-if="isShow" />
	<!-- <RouterHeader :menuList="menuList"/> -->
    <router-view class="routerbox" :lan="lan" @change="changeTab" @changeShow="changeShow"/>
    <router-footer :lan="lan" :menuList="menuList" v-if="isShow" />
	
  </div>
</template>
<script>
import RouterHeader from "@/components/RouterHeader.vue";
import RouterFooter from "@/components/RouterFooter.vue";
export default {
  components: {
    RouterHeader,
    RouterFooter,
  },
  data() {
    return {
      lan: "cn",
      index: 0,
      detail: "",
      menuList: [],
      isShow:true,
      
    };
  },
  mounted(){
    window.addEventListener('hashchange',()=>{
		var currentPath = window.location.hash.slice(1); // 获取输入的路由
      if(this.$router.path !== currentPath){
        this.$router.push(currentPath); // 动态跳转
      }
    },false);
	
	let lan = sessionStorage.getItem("lan");
	if (lan == null) {
	  sessionStorage.setItem("lan", "cn");
	} else {
	  this.lan = lan;
	}
	this.seo();
	this.categoryList("资讯");
	
	
  },
  methods: {
    changeShow(e){
      console.log(e)
      this.isShow = e
    },
    change() {
      let lans = sessionStorage.getItem("lan");
      this.lan = lans;
      if (this.$route.path == "/WineCultureBreed") {
        this.$router.go(-1);
        
        return;
      }
      if (this.$route.path == "/InformationDetails") {
        this.$router.push("/InformationList");
        
        return;
      }
      if (this.$route.path == "/ProductDetails") {
        if (this.$route.query.type == "ProductList") {
          this.$router.push("/ProductList");
          
        } else {
          this.$router.push("/WineryList");
          
        }
        return;
      }
      if (this.$route.path == "/WineryDetails") {
        this.$router.push("/WineryList");
        
        return;
		
      }
      if(this.$route.path == '/DownLoad'){
        console.log(1)
        this.isShow = false
      }
    },
    categoryList(name) {
      this.$http.post("/index/article/categoryList", { name }).then((res) => {
        this.menuList = res.data.data[0].children;
        console.log(this.menuList,'this.menuList')
        // 公告栏目(93)后端未配置子分类：取首页公告板块的三个公告分类
        // （财达公告/交易提示/交易公告）挂为子分类，保证头部/底部悬浮菜单正常显示
        const gg = this.menuList.find((m) => m.id == 93);
        if (gg && (!gg.children || gg.children.length === 0)) {
          this.$http.post("/index/article/index", { index: 3 }).then((res2) => {
            this.$set(
              gg,
              "children",
              (res2.data.data || []).map((c) => ({
                id: c.id,
                name: c.name,
                content_type: 0,
                children: [],
              }))
            );
          });
        }
      });
    },
    changeTab(i) {
      this.index = i;
    },
    seo() {
      document.title = "财达期货";
    },
  },
  mounted() {
    let lan = sessionStorage.getItem("lan");
    if (lan == null) {
      sessionStorage.setItem("lan", "cn");
    } else {
      this.lan = lan;
    }
    this.seo();
    this.categoryList("资讯");
  },
};
</script>
<style>
/* @media screen and (max-width: 280px) {
    html {
      transform: scale(0.7);
      transform-origin: top left;
    } */
* {
  font-family: Microsoft YaHei, Microsoft YaHei;
  /* background: #F9F9F9; */
}

img {
  object-fit: cover;
  /* display: block; */
}

video {
  object-fit: cover;
  display: block;
}
</style>
<style lang="scss">
p{
  margin: 0 0 !important;
}
 .ql-align-right{
  text-align: right !important;
}

 .ql-align-left{
  text-align: left !important;
}

 .ql-align-center{
  text-align: center !important;
}

.index {
  .swiper1 {
    position: relative;

    .box {
      position: absolute;
      width: 100%;
      height: 100px;

      @media (max-width: 1199px) {
        height: auto;
      }

      top: 50%;
      transform: translate(0%, -50%);
      // left: 25%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      text-align: center;

      .content {
        font-size: 69px;
        color: #ffffff;
        line-height: 100px;
        font-weight: lighter;

        @media (max-width: 1199px) {
          font-size: 30px;
          line-height: 70px;
        }
      }
    }
  }
}

.line {
  width: 100px;
  height: 4px;
  margin-top: 10px;
  display: flex;
  background-color: #f1f1f1;
  justify-content: space-between;

  :first-child {
    width: 33.33%;
    background-color: #009344;
  }

  :last-child {
    width: 33.33%;
    background-color: #ee3d42;
  }
}

.winery {
  width: 100%;

  // background-color: red;
  > :first-child {
    text-align: center;
    font-size: 30px;

    @media (max-width: 1199px) {
      font-size: 20px !important;
    }

    font-family: Italicc !important;
    font-weight: normal;
    color: #c5a176;
  }

  > :nth-child(2) {
    text-align: center;
    margin-top: 10px;
    font-size: 30px;

    @media (max-width: 1199px) {
      font-size: 24px !important;
    }

    font-family: Regular;
    font-weight: 500;
    color: #6f655d;
  }

  > :nth-child(3) {
    margin: auto;
    margin-top: 10px;
  }

  > :nth-child(4) {
    text-align: center;
    margin-top: 20px;
    font-size: 18px;

    @media (max-width: 1199px) {
      font-size: 14px !important;
      width: 90%;
      margin: auto;
      margin-top: 0px;
    }

    font-family: Italic;
    font-weight: 400;
    color: rgba(111, 101, 93, 0.8);
  }
}

.el-drawer__header {
  margin-bottom: 0px !important;
}

.el-drawer__close-btn {
  background-color: white !important;
}

.el-drawer__open .el-drawer.rtl {
  width: 60% !important;
  background: #c11226 !important;
  color: white !important;
}

.el-drawer.rtl {
  background: #c11226 !important;
  color: white !important;
}

.el-drawer__body > * {
  width: 100% !important;
  height: 50px !important;
  line-height: 50px !important;
  text-align: center !important;
  padding: 0px 10px !important;
  // border-bottom: 1px solid white !important;
}

// .el-drawer__body > * :first-child {
//   border-top: 1px solid white !important;
// }

.routerbox {
  padding-top: 80px;
  // background: #f9f9f9;
  // padding-top: 111px;
  @media (max-width: 1199px) {
    padding-top: 0px;
  }
}
.app {
  background: #f9f9f9;
}
</style>



// WEBPACK FOOTER //
// src/App.vue